export default {
  data() {
    return {
      loadingInstance: null
    }
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
    },
    hideLoading() {
      this.loadingInstance.clear();
    }
  }
}